import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify, {
  VCarouselTransition,
  VCarouselReverseTransition,
  VDialogTransition,
  VDialogBottomTransition,
  VFabTransition,
  VFadeTransition,
  VMenuTransition,
  VScaleTransition,
  VScrollXTransition,
  VScrollXReverseTransition,
  VScrollYTransition,
  VScrollYReverseTransition,
  VSlideXTransition,
  VSlideXReverseTransition,
  VSlideYTransition,
  VSlideYReverseTransition,
  VTabReverseTransition,
  VTabTransition,
  VExpandTransition,
  VExpandXTransition
} from 'vuetify/lib'

// usage: https://vuetifyjs.com/
Vue.use(Vuetify, {
  components: {
    VCarouselTransition,
    VCarouselReverseTransition,
    VDialogTransition,
    VDialogBottomTransition,
    VFabTransition,
    VFadeTransition,
    VMenuTransition,
    VScaleTransition,
    VScrollXTransition,
    VScrollXReverseTransition,
    VScrollYTransition,
    VScrollYReverseTransition,
    VSlideXTransition,
    VSlideXReverseTransition,
    VSlideYTransition,
    VSlideYReverseTransition,
    VTabReverseTransition,
    VTabTransition,
    VExpandTransition,
    VExpandXTransition
  }
})

const opts = {
  // theme: { disable: true }

  theme: {
    themes: {
      dark: {
        primary: '#ffffff',
        secondary: '#ffffff',
        accent: '#D94848',
        error: '#D94848',
        background: '#02A3F0'
      },
      light: {
        primary: '#ffffff', // color="primary"
        secondary: '#0091D7',
        accent: '#D94848',
        error: '#D94848',
        background: '#A0E1F5'
      }
    }
  }
}

export default new Vuetify(opts)
